import moment from "moment"
import { getKeyByValueOfJson, getValueByKeyOfJson } from "../../Configs/Validator/FormValidations"
import educationData from "../JSON/educationData.json"
import maritalStatusData from "../JSON/maritalStatusData.json"
import occupationData from "../JSON/occupationData.json"
import organizationTypeData from "../JSON/organizationTypeData.json"
import stateData from "../JSON/stateData.json"
import { toJS } from "mobx"
import CalculatorStore from "../Store/calculator"

const IP_URL = "https://httpbin.org/ip"
const LEAD_URL = "https://api.icicilife.com/leadws"
const TRACER_API_KEY = "ea0403e8f3b40e3211d51907ee489b79547bdd1dae6e491556de5956e77b149be974472b6c75543d548cb4d69f85489c"
const TRACER_URL = "https://buy.icicilife.com/IpruApi/api/tracer?api-key=" + TRACER_API_KEY
const GROUP_EMP_URL = "https://buy.icicilife.com/buy/LDAPAuthentication"
const FUND_API_BASE_URL = "https://buy.icicilife.com/buy/funds-by-product.htm?productCode=UW3"
const FUND_DETAIL_BASE_URL = "https://buy.icicilife.com/buy/funds-product-performance.htm"
var checkloaded = false
var RestoreDatLayer_Interval_Count = 0

const FundAPI = async () => {
  var startDate = moment().subtract(7, "days").format("DD-MMM-YY")
  var endDate = moment().format("DD-MMM-YY")
  var FUND_URL = FUND_API_BASE_URL + "&startDate=" + startDate + "&endDate=" + endDate

  const reqParams = {
    method: "GET"
  }

  const response = await fetch(FUND_URL, reqParams)
    .then((res) => res.json())
    .then(async (result) => {
      var updatedFund = await FundDetailAPI(result, startDate, endDate)
      // console.info("Fund Return :", result)
      return updatedFund
    })
    .catch(async (error) => {
      // var updatedFund = await FundDetailAPI(fundPerformJson, startDate, endDate)
      // console.info("Fund Error Return :", updatedFund)
      // return updatedFund
    })

  // console.info("Start Date :", startDate)
  // console.info("End Date :", endDate)

  return response
}

// https://buy.icicilife.com/buy/funds-product-performance.htm?fundCode=F50F&startDate=20-MAR-19&endDate=26-NOV-21

const FundDetailAPI = async (resultArray, startDate, endDate) => {
  var finalArray = []
  const reqParams = {
    method: "GET"
  }

  for (var i = 0; i < resultArray.length; i++) {
    var FUND_DETAIL_URL = FUND_DETAIL_BASE_URL + "?fundCode=" + resultArray[i]["LAfundCode"] + "&startDate=" + startDate + "&endDate=" + endDate
    const response = await fetch(FUND_DETAIL_URL, reqParams)
      .then((res) => res.json())
      .then(async (result) => {
        var value = result["fundSummary"][0]["assetsInvested"]
        resultArray[i]["AssetsInvested"] = value
        finalArray.push(resultArray[i])
        // console.info("Fund Detail Return :", result["fundSummary"])
        return finalArray
      })
      .catch((error) => {
        resultArray[i]["AssetsInvested"] = "-"
        finalArray.push(resultArray[i])
        // console.info("Fund Detail Error Return :", error)
        return finalArray
      })
  }

  return finalArray
}

const ipAPI = async () => {
  const reqParams = {
    method: "GET"
  }

  const response = await fetch(IP_URL, reqParams)
    .then((res) => res.json())
    .then((result) => {
      // console.info("IP Return :", result)
      return result
    })
    .catch((error) => {
      // console.info("Error :", error)
      return error
    })

  // console.info("IP Response :", response)
  return response
}

const leadWSAPI = async (formStore, Suit_LMS12) => {
  var MAIN_URL = window.location.href
  var URL_OBJ = new URL(MAIN_URL)
  var uidCode = URL_OBJ.searchParams.get("UID")

  var glbUid = uidCode === null || uidCode === undefined || uidCode === "" ? 480 : uidCode
  window.Glb_UID = glbUid

  var PROD_CODE = window.UserInput["productId"] //FormStore.quote_formTab === "0" ? "I13" : "I14"
  var LMS_column_12 = "YES"
  if (typeof Suit_LMS12 === "boolean") {
    LMS_column_12 = Suit_LMS12 ? "YES" : "NO"
  } else {
    LMS_column_12 = formStore.calc_checkOne ? "YES" : "NO"
  }

  var pageURL = new URL(window.location.href)
  var temp_obj = {
    utm_campaign: pageURL.searchParams.get("utm_campaign") != null ? pageURL.searchParams.get("utm_campaign") : "",
    utm_keyword: pageURL.searchParams.get("utm_term") != null ? pageURL.searchParams.get("utm_term") : "",
    utm_adcontent: pageURL.searchParams.get("utm_content") != null ? pageURL.searchParams.get("utm_content") : "",
    utm_source: pageURL.searchParams.get("utm_source") != null ? pageURL.searchParams.get("utm_source") : ""
  }
  temp_obj = JSON.stringify(temp_obj)

  const bodyLeadWS = {
    LMS_uid: glbUid,
    LMS_product_code: PROD_CODE,
    LMS_gender: formStore.calc_gender,
    LMS_dob: formStore.calc_dob,
    LMS_mobile: formStore.calc_phone,
    LMS_email: formStore.calc_email,
    //LMS_product_specific: "google_search_q-,call-Yes,vCommId-",
    keyword: "",
    LMS_TRAI_FLAG: formStore.calc_checkOne ? "YES" : "NO",
    matchtype: "",
    LMS_firstName: window.UserInput["name"].substring(0, window.UserInput["name"].indexOf(" ")),
    LMS_lastName: window.UserInput["name"].substring(window.UserInput["name"].indexOf(" ") + 1),
    LMS_tobacco: "",
    LMS_sumassured: window.UserInput["lifeCover"],
    LMS_policyTerm: window.UserInput["term"],
    LMS_policypaymentfrequency: window.UserInput["mode"],
    LMS_staff: window.UserInput["staff"],
    Lumpsum: "0",
    Monthly_income: "0",
    Term_critical_illness: "Self",
    LMS_pageName: "savings : ulip-insurance-plans : icici-pru-smart-kid",
    LMS_pageURL: window.location.href,
    LMS_session_id: "",
    LMS_typeofplan: window.UserInput["payout"],
    LMS_column_1: "1",
    LMS_column_2: "",
    LMS_column_3: formStore.calc_annual,
    LMS_column_4: "",
    LMS_column_5: "",
    LMS_column_6: formStore.calc_buyingFor,
    LMS_column_7: glbUid + "",
    LMS_column_8: "",
    LMS_column_9: "",
    LMS_column_10: "",
    LMS_column_11: formStore.calc_checkTwo ? "YES" : "NO",
    LMS_column_12: LMS_column_12,
    LMS_premium: window.UserInput["premium"],
    LMS_premiumterm: window.UserInput["ppt"],
    LmsAdditionalDetails: JSON.stringify(temp_obj)
  }

  const bodyLeadWSObj = new URLSearchParams()
  for (var i in bodyLeadWS) {
    bodyLeadWSObj.append(i, bodyLeadWS[i])
  }

  const reqParams = {
    method: "POST",
    body: bodyLeadWSObj,
    credentials: "include",
    mode: "cors",
    headers: {
      "x-api-key": "nGKPsiZIBuOKmho81sLMAceokq3mBQVK",
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
    }
  }

  const response = await fetch(LEAD_URL, reqParams)
    .then((res) => res.json())
    .then((result) => {
      // console.info("Lead Return :", result)
      return result
    })
    .catch((error) => {
      // console.info("Lead Error :", error)
      return error
    })

  // console.info("Lead Body :", body)
  // console.info("Lead Response :", response)
  return response
}

const groupEmployeeAPI = async (body) => {
  // console.info("Group Employee Request :", body)
  const reqParams = {
    headers: {
      Accept: "application/json, text/javascript",
      "Content-Type": "application/x-www-form-urlencoded"
    },
    body: body,
    method: "POST",
    credentials: "include",
    mode: "cors"
  }

  const response = await fetch(GROUP_EMP_URL, reqParams)
    .then((res) => res.json())
    .then((result) => {
      // console.info("Group Employee Return :", result)
      return result
    })
    .catch((error) => {
      // console.info("Group Employee Error :", error)
      return error
    })

  // console.info("Group Employee Request :", body)
  // console.info("Group Employee Response :", response)
  return response
}

const DataLayerFn = async (event, CalculatorStore, button) => {
  var UserAge = Math.sign(CalculatorStore.ageValue) === -1 ? "" : CalculatorStore.ageValue
  var eventName = event.split("||")[0]
  var sectionName = event.split("||")[1]

  var tempLayer = {
    event: eventName,
    UID: window.Glb_UID,
    Age: UserAge,
    Button: button,
    Device: window.innerWidth > 768 ? "Desktop" : "Mobile", // Desktop / Mobile
    retirementAge: CalculatorStore.screenNo === "Scr6" ? Math.round(CalculatorStore.retireAgeValue) : "",
    EstimatedReturn: CalculatorStore.screenNo === "Scr6" ? Math.round(CalculatorStore.totalAmtAtRetire) : "",
    AdditionalSavings: CalculatorStore.screenNo === "Scr6" ? Math.round(CalculatorStore.additionalSavingsAmtAtRetire) : "",
    Savings: CalculatorStore.screenNo === "Scr5" || CalculatorStore.screenNo === "Scr6" ? Math.round(CalculatorStore.currentExpensesValue3) : "",
    PostRetirementExpenses: CalculatorStore.currentExpensesValue2 === 0 ? "" : CalculatorStore.screenNo !== "Scr2" ? Math.round(CalculatorStore.currentExpensesValue2) : "",
    currentExpenses: CalculatorStore.currentExpensesValue1 === 0 ? "" : CalculatorStore.screenNo !== "Scr2" ? Math.round(CalculatorStore.currentExpensesValue1) : "",
    NetworkUID1: "", // Mobile No Encrypted in SHA1
    NetworkUID2: "", // Email id Encrypted in SHA1
    ProductCode: "I14",
    ProductName: "GPP DA",
    pageName: "retirement : retirement-pension-plans : pension-planner",
    pageType: "mid-term : pension-planner",
    subsection1: "retirement-pension-plans",
    subsection2: "pension-planner",
    channel: "retirement",
    Subchannel: "retirement-pension-plans",
    SectionName:
      CalculatorStore.screenNo === "Scr1"
        ? "Calculator-Landing page"
        : CalculatorStore.screenNo === "Scr2"
        ? "Calculator-Quote page | Quote Screen"
        : CalculatorStore.screenNo === "Scr3"
        ? "Calculator-Quote page | Current Expenses Screen"
        : CalculatorStore.screenNo === "Scr4"
        ? "Calculator-Quote page | Post-Retirement Expenses Screen"
        : CalculatorStore.screenNo === "Scr5"
        ? "Calculator-Quote page | Savings Screen"
        : CalculatorStore.screenNo === "Scr6"
        ? "Calculator-Result page"
        : ""
  }

  // console.info("DataLayer", tempLayer)
  checkloaded = window.dataLayer.find((item) => item.event === "gtm.load")
  if (!checkloaded) {
    window.tempDataLayer_BeforeCheckLoaded.push(tempLayer)
  } else {
    window.dataLayer.push(tempLayer)
  }
  return ""
}

var RestoreDatLayer_Interval = setInterval(() => {
  checkloaded = window.dataLayer.find((item) => item.event === "gtm.load")
  console.log("setinterval", checkloaded, RestoreDatLayer_Interval_Count)
  if (RestoreDatLayer_Interval_Count > 50 || checkloaded) {
    console.log("setinterval2", checkloaded, RestoreDatLayer_Interval_Count)
    window.dataLayer.push(...window.tempDataLayer_BeforeCheckLoaded)
    window.tempDataLayer_BeforeCheckLoaded = []
    clearInterval(RestoreDatLayer_Interval)
  }
  RestoreDatLayer_Interval_Count++
}, 500)


const tracerAPI = async (FormStore, type) => {
  var MAIN_URL = window.location.href
  var URL_OBJ = new URL(MAIN_URL)
  var uidCode = URL_OBJ.searchParams.get("UID")

  var glbUid = uidCode === null || uidCode === undefined || uidCode === "" ? 480 : uidCode
  window.Glb_UID = glbUid

  var dobVal = FormStore.calc_dob
  var IP_ADD = window.ipAddress
  var associationId = dobVal.split("/")[2] + FormStore.calc_phone.slice(3)
  associationId = type === 1 ? associationId : associationId + "" + IP_ADD

  var ModalPremium = FormStore.quote_invest
  ModalPremium = ModalPremium === "" ? "0" : ModalPremium
  var AnnuityAmount = FormStore.quote_annuityAmount
  AnnuityAmount = AnnuityAmount === "" ? "0" : AnnuityAmount

  var PROD_CODE = window.UserInput["productId"] //FormStore.quote_formTab === "0" ? "I13" : "I14"

  const bodyTracerA = {
    message: "comition",
    properties: {
      amount: "0",
      gender: FormStore.calc_gender,
      cardType: "ICICI BANK",
      mobileNo: FormStore.calc_phone,
      emailID: FormStore.calc_email,
      productCode: PROD_CODE,
      vendorUid: glbUid,
      associationId: associationId, // "19999999999", // "19999999999142.142.142.142"
      premium: ModalPremium,
      message: window.location.hostname + window.location.pathname,
      deviceId: "19 Jun 1989",
      ipAddress: IP_ADD
    },
    source: "ea0403e8f3b40e3211d51907ee489b79547bdd1dae6e491556de5956e77b149be974472b6c75543d548cb4d69f85489c"
  }

  const reqParams = {
    method: "POST",
    body: JSON.stringify(bodyTracerA),
    credentials: "include",
    mode: "cors",
    headers: { "Content-Type": "application/json" }
  }

  const response = await fetch(TRACER_URL, reqParams)
    .then((res) => res.json())
    .then((result) => {
      // console.info("Tracer A Return :", result)
      return result
    })
    .catch((error) => {
      // console.info("Tracer A Error :", error)
      return error
    })

  // console.info("Tracer A Response :", response)
  return response
}

const crashHandler = async (value, altVal) => {
  try {
    return value === undefined ? altVal : value
  } catch {
    return altVal
  }
}

const levelHandler = async (lvl1, lvl2) => {
  try {
    if (lvl2 === "") return window.UserDataJSON[lvl1]
    else return window.UserDataJSON[lvl1][lvl2]
  } catch {
    return ""
  }
}

export { ipAPI, leadWSAPI, tracerAPI, groupEmployeeAPI, DataLayerFn, FundAPI }
